var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center mt-3",staticStyle:{"height":"87%"}},[_c('h1',[_vm._v(" Page Not Found ")]),_c('br')])
}]

export { render, staticRenderFns }